import { ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild } from '@angular/core';

import { CommonModule } from '@angular/common';

import { NavigationLinkDirective } from '../../../directives/navigation-link/navigation-link.directive';
import { ActionItem, OpenDirection } from '../../action-item/entities/action-item.entity';
import { ShIconModule } from '../../icon/icon.module';

@Component({
    standalone: true,
    selector: 'sh-compact-navigation-main-action',
    templateUrl: 'compact-navigation-main-action.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, ShIconModule, NavigationLinkDirective]
})
export class ShCompactNavigationMainActionComponent {
    @Input() item!: ActionItem;

    @ViewChild('detailsElement', { read: ElementRef }) detailsElement!: ElementRef<HTMLDetailsElement>;

    get hasDropmenuItems(): boolean {
        return 'actionItems' in this.item;
    }

    get openDropmenuAbove(): boolean {
        const aboveDirections: OpenDirection[] = [
            OpenDirection.AboveLeft,
            OpenDirection.AboveRight,
            OpenDirection.LeftUp,
            OpenDirection.RightUp
        ];
        return this.item.openDirection && aboveDirections.includes(this.item.openDirection) ? true : false;
    }

    closeSubMenu(): void {
        this.detailsElement.nativeElement.removeAttribute('open');
    }

    openSubMenu(): void {
        this.detailsElement.nativeElement.setAttribute('open', 'true');
    }

    actionClicked(event: MouseEvent, actionItem: ActionItem) {
        this.closeSubMenu();

        if (actionItem.eventListener) {
            actionItem.eventListener.call(null, event);
        }
    }
}
